/**
 * Module-level flag telling `Questionnaire`'s empty-page auto-skip that a
 * fast-track run currently owns navigation.
 *
 * Why it exists: when the fast-track lands on the first questionnaire page,
 * the route change rebuilds that page's section queues, which transiently
 * empties the display queue even though the KB wave has already delivered the
 * landing question (observed live: gate resolves on `CONSULTATION:dq=1`, the
 * landing rebuild flashes `dq=0`, and the auto-skip walks the app forward to
 * COMPLAINTS/PREVENTION before the question re-arrives — while a manual
 * click-through rests on the landing page). During a run, any empty-page
 * condition is transient and the runner — not the auto-skip — owns
 * navigation, so the skip must stand down until the run completes or fails.
 *
 * A module flag rather than Redux state because the skip effect decides
 * synchronously at fire time; the flag is always set before the runner
 * navigates anywhere near a questionnaire route and cleared only when the run
 * finishes, so there is no render-timing hole to bridge.
 */

let active = false;

export const setRunActive = (value: boolean): void => {
  active = value;
};

export const isRunActive = (): boolean => active;
